import React, { useId } from 'react';
import { styles } from './styles';

const STEAM = [
  'M 460 405 Q 477.6 377.7 475.0 362.15 Q 472.4 346.6 466.6 334.7 Q 460.8 322.8 460 295 Q 442.4 322.8 445.0 338.5 Q 447.6 354.2 453.4 365.95 Q 459.2 377.7 460 405 Z',
  'M 512 413 Q 533.9 375.8 530.65 354.95 Q 527.4 334.1 519.95 317.55 Q 512.5 301 512 263 Q 489.9 301 493.25 321.95 Q 496.6 342.9 503.95 359.35 Q 511.3 375.8 512 413 Z',
  'M 564 399 Q 578.4 376.7 575.95 363.95 Q 573.5 351.2 568.65 341.5 Q 563.8 331.8 564 309 Q 549.6 331.8 552.05 344.6 Q 554.5 357.4 559.35 367.05 Q 564.2 376.7 564 399 Z',
];

const CUP = 'M 412 440 C 372 500, 337 590, 337 650 C 337 690, 380 740, 412 740 L 612 740 C 644 740, 687 690, 687 650 C 687 590, 652 500, 612 440 Z';

const BUTTONS = [
  { cx: 570, cy: 504 },
  { cx: 606, cy: 540 },
  { cx: 570, cy: 576 },
  { cx: 534, cy: 540 },
];

export default function PlayerCafeMark(props: {
  size: number | string;
  title?: string;
}): JSX.Element {

  const gradientId = `playercafe-mark-${useId().replace(/:/g, '')}`;
  const fill = `url(#${gradientId})`;

  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="327 253 482 497"
      xmlns="http://www.w3.org/2000/svg"
      role={props.title ? 'img' : 'presentation'}
      aria-hidden={props.title ? undefined : true}
      aria-label={props.title}
      style={styles.svg}
    >
      {props.title && <title>{props.title}</title>}
      <defs>
        <radialGradient id={gradientId} cx="512" cy="590" r="190" gradientUnits="userSpaceOnUse">
          <stop offset="0%" style={styles.stopFrom} />
          <stop offset="100%" style={styles.stopTo} />
        </radialGradient>
      </defs>
      {STEAM.map((d) => <path key={d} d={d} fill={fill} />)}
      <path d="M 634 480 A 92 92 0 1 1 641 630" fill="none" stroke={fill} strokeWidth={32} strokeLinecap="round" />
      <path d={CUP} fill={fill} />
      <ellipse cx={512} cy={440} rx={100} ry={18} fill={fill} />
      <rect x={390} y={624} width={110} height={32} rx={5} style={styles.cutout} />
      <rect x={429} y={585} width={32} height={110} rx={5} style={styles.cutout} />
      {BUTTONS.map((button) => <circle key={`${button.cx}-${button.cy}`} cx={button.cx} cy={button.cy} r={17} style={styles.cutout} />)}
    </svg>
  );

}
